import { Info } from "@components";
import classNames from "classnames";
import { useState } from "react";

import Label from "../_shared/label";

interface TextareaProps extends React.ComponentProps<"textarea"> {
  name: string;
  info?: string;
  label?: string;
  required?: boolean;
  inputRef?: React.Ref<HTMLTextAreaElement>;
  error?: string;
}

export function Textarea({
  name,
  placeholder,
  info = "",
  label = "",
  required = false,
  value = "",
  onChange = () => {},
  inputRef = null,
  error = "",
  autoComplete = "on",
  rows = 4,
}: TextareaProps) {
  const [displayInfo, setDisplayInfo] = useState(false);

  return (
    <div className="flex flex-col w-full">
      <Label
        name={name}
        label={label}
        info={info}
        error={error}
        required={required}
        displayInfo={displayInfo}
        infoId={`${name}-info`}
        setDisplayInfo={setDisplayInfo}
      />
      <textarea
        ref={inputRef}
        id={name}
        name={name}
        rows={rows}
        className={classNames(
          "peer",
          "border bg-page",
          "w-full p-2  rounded",
          "focus:ring-2 focus:outline-none",
          {
            "border-default": !error,
            "border-danger": !!error,
          },
        )}
        onChange={onChange}
        value={value}
        autoComplete={autoComplete}
        placeholder={placeholder}
      />
      <p className="text-xs ml-1 mt-1 text-danger font-comfortaa">{error}</p>
      <Info id={`${name}-info`} info={info} displayInfo={displayInfo} />
    </div>
  );
}

export default Textarea;
